var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFoodCold = function SvgFoodCold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 19.2 17.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M18.6 8.6c-.769-.667-2.231-.667-3 0s-2.231.667-3 0-2.231-.667-3 0-2.231.667-3 0-2.231-.667-3 0-2.231.667-3 0m2-4h14a2 2 0 1 0 0-4h-14a2 2 0 1 0 0 4m0 12h14a2 2 0 1 0 0-4h-14a2 2 0 1 0 0 4"
  })));
};
export default SvgFoodCold;